module.exports = __webpack_public_path__ + "img/symbol_4.73e0e9f4.png";